import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ChangeDetectorRef,
  ElementRef,
  OnDestroy,
} from '@angular/core'
import {
  CmsBreadcrumbsComponent,
  PageMeta,
  PageMetaService,
  TranslationService,
} from '@spartacus/core'
import { BehaviorSubject, combineLatest, Observable, of, Subscription } from 'rxjs'
import { filter, map, switchMap, take } from 'rxjs/operators'
import { BreadcrumbService } from './breadcrumb.service'
import { CmsComponentData } from '@spartacus/storefront'
import { Router, NavigationStart } from '@angular/router'

@Component({
  standalone: false,
  selector: 'cx-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  title$: Observable<string>
  crumbs$: Observable<any[]>

  titleSubscription: Subscription
  crumbsSubscription: Subscription
  crumbs: any
  showBreadcrumbSubscription: any

  constructor(
    public component: CmsComponentData<CmsBreadcrumbsComponent>,
    protected pageMetaService: PageMetaService,
    private translation: TranslationService,
    public breadCrumbService: BreadcrumbService,
    private cRef: ChangeDetectorRef,
    private router: Router,
    public elRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.crumbs$ = this.breadCrumbService.isCustomBreadcrumb$.pipe(
      switchMap((isCustom: boolean) => 
        isCustom ? this.breadCrumbService.breadCrumbs$ : this.setCrumbs()
      )
    );

    this.title$ = this.breadCrumbService.isCustomBreadcrumb$.pipe(
      switchMap((isCustom: boolean) => 
        isCustom ? this.breadCrumbService.breadCrumbTitle$ : this.setTitle()
      )
    );

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.breadCrumbService.setCustomBreadcrumbFlag(false);
      }
    });

    this.showBreadcrumbSubscription = this.breadCrumbService.showBreadcrumb$.subscribe(
      (res) => this.showBreadcrumb(res)
    );
    
    this.breadCrumbService.setShowHideBreadcrumb(true);
  }

  ngOnDestroy(): void {
    this.showBreadcrumbSubscription.unsubscribe()
  }

  private setTitle() {
    return this.pageMetaService.getMeta().pipe(
      filter(Boolean),
      map((meta: PageMeta) => meta.heading || meta.title)
    )
  }

  private setCrumbs() {
    return combineLatest([
      this.pageMetaService.getMeta(),
      this.translation.translate('common.home'),
    ]).pipe(
      map(([meta, textHome]) =>
        meta?.breadcrumbs ? meta.breadcrumbs : [{ label: textHome, link: '/' }]
      )
    )
  }

  private showBreadcrumb(value) {
    if (!value) {
      this.elRef.nativeElement.style.display = 'none'
    } else {
      this.elRef.nativeElement.style.display = 'block'
    }
  }
}
